import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import LayoutNoSidebar from '../../../Layout/LayoutNoSidebar';
import './AboutUs.scss';

const AboutUs = () => {
    return (
        <LayoutNoSidebar>
            <div className="about-us-container pb-80">
                <Row>
                    <Col md={6} className="mb-4">

                        <h2 className="section-title">Our Story</h2>
                        <p>
                            ShareGratitude was born from the extraordinary acts of care witnessed during the COVID-19 pandemic and from the lived experiences of our founders, Don Amal Francis and NHS surgeon Dr Janindra Warusavitarne, both as a clinician and as patients.
                        </p>
                        <p>
                            Moved by the public's desire to show appreciation, they self-funded a global initiative that reached over three million people across eighteen countries, but soon realised that broad public positivity, while powerful, rarely reached the individual staff who needed it most. Real impact required something more focused, more personal, and sustainably embedded into everyday healthcare.
                        </p>
                        <p>
                            Working with staff, patients, and system leaders, they designed HUMAN by ShareGratitude: a safe, turnkey, and scalable programme that delivers real time one-to-one appreciation directly to staff mobile phones, restoring the patient-to-staff connection and driving psychological safety.
                        </p>
                        <p>
                            What began as a public movement has evolved into a globally adopted workforce intervention, transforming morale and wellbeing by putting human appreciation back at the heart of healthcare.
                        </p>
                    </Col>
                    <Col md={6} className="raison-section">
                        <h2 className="section-title">Our Raison-D'être</h2>
                        <p className="raison-text">
                            We believe that when staff feel valued, they thrive, and when staff thrive, care and safety improve. Our purpose is simple: Ensure every healthcare professional feels appreciated, supported and seen, every single day.
                        </p>
                        <p className="raison-core">
                            This remains at the core of everything we do.
                        </p>

                        <div className="founders-section mt-2">
                            <h5 className="founders-names">Dr Janindra Warusavitarne & Don Amal Francis</h5>
                            <div className="signatures my-4">
                                <img
                                    src="https://human.sharegratitude.com/wp-content/uploads/2023/08/WhatsApp_Image_2023-08-06_at_5.08.55_PM-removebg-preview-1-360x87.png"
                                    alt="Signatures of Dr Janindra Warusavitarne & Don Amal Francis"
                                    className="signature-image"
                                />
                            </div>
                            <Button
                                variant="outline-dark"
                                className="read-story-btn"
                                onClick={() => window.open('https://human.sharegratitude.com/founding-story/', '_blank')}
                            >
                                READ FOUNDING STORY
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </LayoutNoSidebar>
    );
};

export default AboutUs;
